module.exports = __webpack_public_path__ + "static/media/45.20df78e8.webp";